var LOBS = 'flights hotels bus cab train holidays activities growth common metro offers visa payment'.split(' ');
var isValidLobName = function isValidLobName(lob) {
  return LOBS.includes(lob);
};

var MOBILE_NUMBER_REGEX = /\d{10}$/;
var EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

var isMobileNumber = function isMobileNumber(mobileNumber) {
  if (mobileNumber) {
    if (Number.isNaN(Number(mobileNumber)) || typeof mobileNumber === 'string' && mobileNumber.length !== 10) {
      return false;
    }

    if (MOBILE_NUMBER_REGEX.test(mobileNumber)) {
      return true;
    }
  }

  return false;
};

var isEmail = function isEmail(email) {
  if (EMAIL_REGEX.test(email)) {
    return true;
  }

  return false;
};

var validateOtp = function validateOtp(input) {
  return /^[0-9]+$/.test(input);
};

export { LOBS, isEmail, isMobileNumber, isValidLobName, validateOtp };
